import { IaOLOUser } from "../models/user-olo.interface"

export interface ISignUpResponse { }

export interface ISignIn {
    email: string,
    password: string,
    app?: boolean,
    rememberMe?: boolean,
    incompleteProfile?: boolean,
    mfaTrustToken?: string | null,
    mfaSessionToken?: string | null
}

/** Message codes the Loyalty API returns for the sign-in and account-action MFA flows. */
export const MfaMessage = {
    Required: "MfaRequired",
    NotRequired: "MfaNotRequired",
    ChallengeExpired: "MfaChallengeExpired",
    CodeInvalid: "MfaCodeInvalidOrExpired",
    TooManyAttempts: "MfaTooManyAttempts"
} as const;

export interface IMfaVerify {
    store_key: string,
    challenge_id: string,
    code: string,
    trust_browser: boolean
}

/** No challengeId means no prompt: MFA is off for the brand, or the customer is out of attempts. */
export interface IAccountMfaStart {
    challengeId: string | null,
    message?: string
}

export interface ISignInSSO {
    location: string,
    sso_token: string,
    store_key: string
}

export interface ISignInGoogle {
    store_key: string,
    location: string,
    id_token: string,
    remember_me: boolean,
    app: boolean,
    nonce?: string
}

export interface ISignInPhone {
    store_key: string,
    phone: string,
    country_id: number,
    code: string,
    app: boolean,
    remember_me: boolean
}

export interface ISignInResponse {
    success: boolean,
    user?: IaOLOUser,
    jwt?: string,
    refreshToken?: string
    token?: string,
    timeout?: boolean,
    /**
     * Google flow: no profile exists yet for the verified email. No account was created and no
     * session issued -- send the customer through sign-up, prefilled from `googleIdentity`.
     */
    isNewProfile?: boolean,
    googleIdentity?: IGoogleIdentity,
    /** Server-supplied reason a sign-in was refused. */
    message?: string,
    /** Set when the password was right but MFA must be completed before a session is issued. */
    mfaChallengeId?: string,
    /** The customer closed the MFA prompt, so no session was issued and no error should be shown. */
    mfaCancelled?: boolean,
    mfaSessionToken?: string,
    mfaTrustToken?: string
}

/** Identity from a Google ID token, after server-side verification. */
export interface IGoogleIdentity {
    email: string,
    firstName: string,
    lastName: string
}

//export interface IGetUserResponse {
//    success: boolean,
//    message?: string,
//    user?: IUser,
//    jwt?: string,
//    timeout: boolean
//}

export interface IGetPhoneCodeResponse {
    success: boolean,
    message: string
}

export interface IFetchFavoriteStoresResponse {
    storeKey: string,
    name: string
}

export interface IFetchOrderDetails {
    DELCHG: number,
    DISC: number,
    GRAT: number,
    Items: IFetchOrderDetailsItems[],
    ODATE: string,
    OID: number,
    ONUM: number,
    OTYPE: string,
    Payments: IFetchOrderDetailsPayments[],
    SNAME: string,
    SSTRNUM: string,
    SADDR1: string,
    SADDR2: string,
    SADDR3: string,
    SADDR4: string,
    SADDR5: string,
    SCITY: string,
    SSTATE: string,
    SZIP: string,
    SCID: number,
    SPHN: string,
    SUBTLT: number,
    TAX: number
}

interface IFetchOrderDetailsItems {
    COM: string,
    HHPRC: number,
    HIDX: number,
    MODS: IFetchOrderDetailsModifiers[],
    NAM: string,
    PRC: number,
    QTY: number,
    SIZE: string
}

interface IFetchOrderDetailsModifiers {
    IDEFPREMOD: boolean,
    MODNAM: string,
    PREMODNAM: string
}

interface IFetchOrderDetailsPayments {
    ACCID: number,
    AMT: number,
    CDUE: number,
    CTID: number,
    GRAT: number,
    NAM: string,
    PTID: number
}

export interface IChangePassword {
    oldPassword: string,
    newPassword: string,
    /** Google credential proving a re-authorization; only sent when adding a first password. */
    idToken?: string
}

export interface IChangePasswordResponse {
}

export interface IResetPassword {
    profileId: string, //is encrypted string
    storeKey: string,
    password: string
}

export interface IResetPasswordResponse {
    success: boolean,
    isProfileComplete: boolean
}

export interface IForgotPassword {
    store_key: string,
    email: string,
    is_olo3: boolean
}

export interface IUnsubscribeDto {
    storeKey: string,
    profileId: number,
    campaignRunId: number,
    reasons: number[],
    otherReason: string
}

export interface IGetProfileResponse {
    success: boolean,
    profile: string
}